export const Colors = {
    primary: '#008384',
    secondary: '#FF9A3D',
    base: '#e0ebeb',
    bg: '#E5E5E5'
    

}
